import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { AppSupervisorPersonalFiltersDef } from "./AppSupervisorPersonalFiltersDef";

export const AppSupervisorIcon = IconDashboard;
export const AppSupervisorHelpText = '* AppSupervisor.';

export class AppSupervisorPersonalFilters extends Entity<AppSupervisorPersonalFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new AppSupervisorPersonalFiltersDef(), parentKeys);
        this.Form = import('./AppSupervisorPersonalFiltersForm').then((module) => module.AppSupervisorPersonalFiltersForm);
        this.Title = "AppSupervisor";
        this.HelpText = AppSupervisorHelpText;
        this.Icon = AppSupervisorIcon;
    }
}